import { toast } from 'react-toastify';

export class Toaster {
  static error(text, options) {
    toast.error(text, {
      position: 'top-left',
      autoClose: 6000,
      closeOnClick: true,
      ...options,
    });
  }
  static info(text, options) {
    toast.info(text, {
      position: 'top-left',
      autoClose: 6000,
      closeOnClick: true,
      ...options,
    });
  }
  static warn(text, options) {
    toast.warn(text, {
      position: 'top-left',
      autoClose: 6000,
      closeOnClick: true,
      ...options,
    });
  }
  static success(text, options) {
    toast.success(text, {
      position: 'top-left',
      autoClose: 6000,
      closeOnClick: true,
      ...options,
    });
  }
}
